import type { ThemeOptions } from '@mui/material';
import { createTheme } from '@mui/material';
import { blueGrey } from '@mui/material/colors';

const themeOptions: ThemeOptions = {
  palette: {
    primary: {
      light: '#545454',
      main: '#212121',
      dark: '#000000',
    },
    secondary: {
      light: '#F8B0A2',
      main: '#F15F43',
      dark: '#C02B0E',
    },
    background: {
      default: '#fff',
      paper: blueGrey[50],
    },
  },
  shape: {
    borderRadius: 3,
  },
  typography: {
    htmlFontSize: 12,
    fontSize: 10,
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          backgroundColor: blueGrey[50],
          color: theme.palette.primary.main,
        }),
      },
    },
  },
};

export const light = createTheme(themeOptions);
